import { createModelSegment } from 'client/data/luckdragon/segment';

export const VenomVersion = createModelSegment('venomVersion', []);
